import React from "react";

const Index = React.lazy(() => import("./index"));

export const PROFIT_AND_LOSS_PATH = "/admin/profitAndLoss";
export const PROFIT_AND_LOSS_SCHEDULED_PATH =
	"/admin/scheduledForProfitAndLoss";

export const profitAndLossRoutes = [
	{
		path: PROFIT_AND_LOSS_SCHEDULED_PATH,
		name: "Scheduled For Profit And Loss",
		element: <Index />,
	},
	{
		path: PROFIT_AND_LOSS_PATH,
		name: "Profit And Loss",
		element: <Index />,
	},
];
